module.exports = __webpack_public_path__ + "static/TANMEMORIES-Italic-aef2b69baaa45dde7192e5db5b3bf66b.eot";